'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdImportContacts = function MdImportContacts(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 30.9v-19.3c-1.8-0.5-3.8-0.7-5.9-0.7-2.8 0-6.8 1.1-9.1 2.5v19.1c2.3-1.4 6.3-2.5 9.1-2.5 2.1 0 4.1 0.3 5.9 0.9z m-5.9-23.4c3.5 0 7.1 0.9 9.3 2.5v24.3c0 0.4-0.5 0.9-0.9 0.9-0.2 0-0.2 0-0.4-0.1-2.3-1.3-5.2-1.7-8-1.7-2.8 0-6.8 1.1-9.1 2.5-2.4-1.8-5.9-2.5-9.1-2.5-2.5 0-5.7 0.7-8 1.8-0.2 0-0.2 0-0.4 0-0.4 0-0.9-0.4-0.9-0.7v-24.5c2.5-1.8 6-2.5 9.3-2.5s6.7 0.7 9.1 2.5c2.4-1.8 5.9-2.5 9.1-2.5z' })
        )
    );
};

exports.default = MdImportContacts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/import-contacts.js
// module id = 3186
// module chunks = 0